import classNames from "classnames";
import compact from "lodash/compact";
import isFunction from "lodash/isFunction";
import size from "lodash/size";
import PropTypes from "prop-types";
import React from "react";

import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";
import { createSanitizedMarkup } from "../../../utils/Utils";

const CustomerReroutePromptCustomSystemMessage = ({ messageActions: rawMessageActions, messageText }) => {
    const messageActions = compact(rawMessageActions);
    const messageActionCount = size(messageActions);
    const rerouteMessageClasses = classNames({
        "system-message": true,
        "message-reroute-question": true,
        "has-sibling": messageActionCount > 0,
    });

    const actions = messageActions.map((action, key) => {
        const isLast = key + 1 === messageActionCount;
        const actionClasses = classNames({
            "system-message": true,
            "has-sibling": !isLast,
        });

        return (
            <div className={actionClasses} key={isLast}>
                {isFunction(action.intent) ? (
                    <a className="system-message-action" onClick={action.intent}>
                        <strong>{action.label}</strong>
                    </a>
                ) : (
                    <a className="system-message-action" href={action.intent} target="_blank" rel="noopener noreferrer">
                        <strong>{action.label}</strong>
                    </a>
                )}
            </div>
        );
    });

    return (
        <li>
            <div className={rerouteMessageClasses}>
                <div className="icon icon-arrow-right">
                    <SvgIcon src={iconSprite} id="icon-arrow-right" />
                </div>
                <p className="body" dangerouslySetInnerHTML={createSanitizedMarkup(messageText)} />
            </div>

            {actions}
        </li>
    );
};

CustomerReroutePromptCustomSystemMessage.propTypes = {
    messageActions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            intent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
        })
    ),
    messageText: PropTypes.string,
};

CustomerReroutePromptCustomSystemMessage.defaultProps = {
    messageActions: [],
    messageText: null,
};

export default CustomerReroutePromptCustomSystemMessage;
